import axios from 'axios';

export const getProfil = async ({ id }) => {
    try {
        const result = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/trader`,
        {
            params: { id },
            withCredentials: true,
            validateStatus: () => true,
        });
        return result.data;
    } catch (_) {
        return {success: false, data: [], error: {code: "SERVER_ERROR", message: "Impossible de contacter le serveur"} };
    }
};

export const getOffers = async ({ id }) => {
    try {
        const result = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/public/offers`,
        {
            params: { id },
            withCredentials: true,
            validateStatus: () => true,
        });
        return result.data;
    } catch (_) {
        return {success: false, data: [], error: {code: "SERVER_ERROR", message: "Impossible de contacter le serveur"} };
    }
};